import { apiRequest } from 'utils/request'

export const getCircuitBundles = ({ circuitNumber }) =>
  apiRequest(`/circuits/${circuitNumber}/bundles`)

export const getCircuitRevisions = ({ circuitNumber }) =>
  apiRequest(`/circuits/${circuitNumber}/revisions`)

export const getCircuitDetails = ({ circuitNumber }) =>
  apiRequest(`/circuits/${circuitNumber}`)

export const getBundleRevisions = ({ bundleNumber }) =>
  apiRequest(`/circuits/${bundleNumber}/revisions`)

export const getBundleDetails = ({ bundleNumber }) =>
  apiRequest(`/bundles/${bundleNumber}`)
